import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PERIPHERAL EQUIPMENT SERVICE');

@Injectable({
  providedIn: 'root'
})
export class PeripheralEquipmentService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'peripheralEquipment' como el nombre del recurso a la clase base
    super('peripheralEquipment');
    log.debug('Servicio de Equipo Periférico inicializado');
  }

}
